import { Injectable } from '@angular/core';

import { ExcelExportEvent as GridExcelExportEvent } from '@progress/kendo-angular-grid';
import { ExcelExportEvent as TreeListExcelExportEvent } from '@progress/kendo-angular-treelist';
import { LogicStyledGridRowCellDictionary } from '../../models';
import { REGULAR_EXPRESSION_CONSTANTS } from '../../shared/constants';

@Injectable({
    providedIn: 'root'
})
export class ExcelExportService {

    constructor() { }

    onExcelExport(e: GridExcelExportEvent | TreeListExcelExportEvent): void {
        const rows = e.workbook.sheets[0].rows;
        // set alternating row color
        let altIdx = 0;
        rows.forEach((row) => {
            if (row.type != "data") {
                return;
            }

            row.cells.forEach((cell) => {
                if (typeof cell.value === 'string' && cell.value?.includes("label") && cell.value?.includes("urlLink")) {
                    this.createURLHyperlink(cell);
                }

                if (REGULAR_EXPRESSION_CONSTANTS.emailPattern.test(cell.value)) {
                    this.createEmailHyperlink(cell);
                }
            });
            if (altIdx % 2 !== 0) {
                row.cells.forEach((cell) => {
                    cell.background = "#F7F7F7";
                });
            }
            altIdx++;

        });
    }

    createURLHyperlink(cell: any): void {
        const label = this.retrieveURLLabel(cell.value);
        const link = this.retrieveURLLink(cell.value);
        cell.value = label;
        cell.formula = `=HYPERLINK("${link}","${label}")`;
        cell.color = '#0070e0';
        cell.underline = true;
    }

    createEmailHyperlink(cell: any): void {
        cell.formula = `=HYPERLINK("mailto:${cell.value as string}","${cell.value as string}")`;
        cell.color = '#0070e0';
        cell.underline = true;
    }

    retrieveURLLabel(stringifiedObject: string): string {
        if (!stringifiedObject || stringifiedObject === "") {
            return;
        }
        const urlObject = JSON.parse(stringifiedObject);
        return urlObject.label;
    }

    retrieveURLLink(stringifiedObject: string): string {
        if (!stringifiedObject || stringifiedObject === "") {
            return;
        }
        const urlObject = JSON.parse(stringifiedObject);

        if (!urlObject.urlLink.includes('http')) {
            urlObject.urlLink = `http://${urlObject.urlLink as string}`;
        }

        return urlObject.urlLink;
    }

    exportReportWithStylesToExcel(exportEvent: GridExcelExportEvent | TreeListExcelExportEvent, logicStyleRowCellMapping: Map<string, LogicStyledGridRowCellDictionary>, activeColumnsIds: string[], includeSubRows: boolean): void {
        const rows = exportEvent.workbook.sheets[0].rows;
        let altIdx = 0;
        rows.forEach((row, rowIndex: number) => {
            if (row.type != "data") {
                return;
            }

            row.cells.forEach((cell, cellIndex: number) => {
                const cellIndexAccountingForSubRows = this.adjustIndexBasedOnSubRows(includeSubRows, row, cellIndex);
                const columnId = activeColumnsIds[cellIndexAccountingForSubRows];
                const rowStyles = logicStyleRowCellMapping.get((rowIndex - 1).toString());

                if (rowStyles?.[columnId]) {
                    cell.background = rowStyles[columnId];
                }
                else if (altIdx % 2 !== 0) {
                    cell.background = "#F7F7F7";
                }

                if (typeof cell.value === 'string' && cell.value?.includes("label") && cell.value?.includes("urlLink")) {
                    this.createURLHyperlink(cell);
                }

                if (REGULAR_EXPRESSION_CONSTANTS.emailPattern.test(cell.value)) {
                    this.createEmailHyperlink(cell);
                }
            });
            altIdx++;
        }
        );
    }

    private adjustIndexBasedOnSubRows(includeSubRows: boolean, row: any, cellIndex: number): number {
        const isAParentRow = cellIndex - 1;
        const isASubRow = cellIndex - 2;

        if (!includeSubRows || row.cells[1].colSpan === 2) {
            return isAParentRow;
        }

        return isASubRow;
    }
}
